import React from 'react';
import { Button, Result } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import { useRedirect } from '../hooks/use-redirect';
import { useLogout } from '../hooks/use-logout';

const NotFound: React.FC = () => {
  const handleGoHome = useRedirect();
  const { handleSignOut } = useLogout();

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="mx-4 text-center">
        <Result
          status="404"
          title={<span className="text-4xl font-bold text-gray-800">404</span>}
          subTitle={
            <span className="text-lg text-gray-600">
              Na vjen keq, faqja që kërkoni nuk ekziston.
            </span>
          }
          extra={
            <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-center">
              <Button
                type="primary"
                size="large"
                icon={<HomeOutlined />}
                onClick={handleGoHome}
                className="min-w-[140px]"
              >
                Kthehu në faqen kryesore
              </Button>
              <Button
                size="large"
                onClick={handleSignOut}
                className="w-full flex items-center gap-2 lg:w-auto h-10 px-6 text-sm font-medium bg-[#003666] hover:bg-[#003666]/90 text-white hover:!text-white"
              >
                Shkoni në login
              </Button>
            </div>
          }
        >
          <div className="mt-4 text-sm text-gray-500">
            <p>
              Faqja që po kërkoni mund të jetë hequr, emri i saj të jetë
              ndryshuar
            </p>
            <p>ose të jetë përkohësisht e padisponueshme.</p>
          </div>
        </Result>
      </div>
    </div>
  );
};

export default NotFound;
